export enum UserRoleInOrder {
  Buyer = 'Buyer',
  Seller = 'Seller',
}
